import { atom } from "jotai";

export const subsedesAtom = atom([]);